import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import type { OnboardAction } from "~/pages/OnboardDocuments";

interface ConfigureStepProps {
  files: File[];
  dispatch: Dispatch<OnboardAction>;
  onNext: () => void;
}

export const ConfigureStep = ({
  onNext: _onNext,
  files: _files,
  dispatch: _dispatch,
}: ConfigureStepProps) => {
  const { t } = useTranslation();

  const placeholder = "Configure step content";

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t(($) => $.library.onboardDocuments.steps.configure.cardTitle)}
        </CardTitle>
        <CardDescription>
          {t(($) => $.library.onboardDocuments.steps.configure.cardDescription)}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-sm">{placeholder}</p>
      </CardContent>
    </Card>
  );
};
